import React, {FC, useEffect} from 'react'
import {KTSVG} from '../../../../../_metronic/helpers'

type Props = {
  action: 'activate' | 'inactivate'
  count: number
  isLoading: boolean
  onConfirm: () => Promise<void>
  onClose: () => void
}

export const BulkStatusConfirmationModal: FC<Props> = ({
  action,
  count,
  isLoading,
  onConfirm,
  onClose,
}) => {
  useEffect(() => {
    document.body.classList.add('modal-open')
    return () => {
      document.body.classList.remove('modal-open')
    }
  }, [])

  const isActivate = action === 'activate'
  const title = isActivate ? 'Activate Selected Users' : 'Inactivate Selected Users'
  const message = `Are you sure you would like to ${isActivate ? 'activate' : 'inactivate'} ${count} selected user${count > 1 ? 's' : ''}?`

  return (
    <>
      <div
        className='modal fade show d-block'
        id='kt_modal_bulk_status_confirm'
        role='dialog'
        tabIndex={-1}
        aria-modal='true'
      >
        <div className='modal-dialog modal-dialog-centered mw-500px'>
          <div className='modal-content'>
            <div className='modal-header'>
              <h2 className='fw-bolder'>{title}</h2>
              <div
                className='btn btn-icon btn-sm btn-active-icon-primary'
                style={{cursor: isLoading ? 'not-allowed' : 'pointer'}}
                onClick={() => {
                  if (!isLoading) onClose()
                }}
              >
                <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-1' />
              </div>
            </div>

            <div className='modal-body text-center py-6'>
              <p className='fs-5 text-gray-800 mb-0'>{message}</p>
            </div>

            <div className='modal-footer justify-content-center py-4'>
              <button
                type='button'
                className='btn btn-light btn-sm me-3'
                disabled={isLoading}
                onClick={onClose}
              >
                Cancel
              </button>
              <button
                type='button'
                className={`btn btn-sm ${isActivate ? 'btn-primary' : 'btn-danger'}`}
                disabled={isLoading}
                onClick={async () => {
                  await onConfirm()
                }}
              >
                {isLoading ? (
                  <span className='indicator-progress d-inline-flex align-items-center'>
                    Please wait...
                    <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                  </span>
                ) : (
                  <span>{isActivate ? 'Activate' : 'Inactivate'}</span>
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className='modal-backdrop fade show'></div>
    </>
  )
}
